import { render, staticRenderFns } from "./RegistroTramiteAdministrativoSection.vue?vue&type=template&id=2552a414&scoped=true"
import script from "./RegistroTramiteAdministrativoSection.vue?vue&type=script&lang=js"
export * from "./RegistroTramiteAdministrativoSection.vue?vue&type=script&lang=js"
import style0 from "./RegistroTramiteAdministrativoSection.vue?vue&type=style&index=0&id=2552a414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2552a414",
  null
  
)

export default component.exports